@if (!changes) {
    <div>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header d-block">
                    <h3 class="text-center">{{ "loadingChanges" | t }}</h3>
                </div>
            </div>
        </div>
    </div>
}

@if (dataSource) {
    <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        data-uiid="history-table-row-body-row"
    >
        <ng-container matColumnDef="Column">
            <th mat-header-cell *matHeaderCellDef>
                {{ "nameHeader" | t }}
            </th>
            <td
                mat-cell
                *matCellDef="let combinedChange; index as i"
                [attr.data-uiid]="'history-table-row-body-row-cell-name-' + i"
            >
                {{ combinedChange.ColumnName }}
            </td>
        </ng-container>
        <ng-container matColumnDef="OldValue">
            <th mat-header-cell *matHeaderCellDef>
                {{ "oldValueHeader" | t }}
            </th>
            <td mat-cell *matCellDef="let combinedChange">
                @for (change of combinedChange.Changes; track change; let i = $index) {
                    <div
                        class="truncate-text"
                        [title]="change.OldValue"
                        [attr.data-uiid]="'history-table-row-body-row-cell-oldvalue-' + i"
                        [class.history-update]="change.HistoryType === HistoryType.update"
                        [class.history-delete]="change.HistoryType === HistoryType.delete"
                    >
                        {{ change.OldValue }}
                    </div>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="NewValue">
            <th mat-header-cell *matHeaderCellDef>
                {{ "newValueHeader" | t }}
            </th>
            <td mat-cell *matCellDef="let combinedChange">
                @for (change of combinedChange.Changes; track change; let i = $index) {
                    <div
                        class="truncate-text"
                        [title]="change.NewValue"
                        [attr.data-uiid]="'history-table-row-body-row-cell-newvalue-' + i"
                        [class.history-update]="change.HistoryType === HistoryType.update"
                        [class.history-insert]="change.HistoryType === HistoryType.insert"
                    >
                        {{ change.NewValue }}
                    </div>
                }
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumn"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumn"></tr>
    </table>
}
